import type { ReactNode } from "react"

export function LandingLayout({ children }: { children: ReactNode }) {
  return (
    <div className="min-h-svh bg-background text-foreground antialiased selection:bg-primary selection:text-primary-foreground">
      {children}
    </div>
  )
}
